export const MAIN_ACTION_STYLE_TYPES = {
  ICON_WITH_TEXT: 1,
  ICON: 2,
};



// WEBPACK FOOTER //
// ./~/wix-vod-shared/src/app-settings/constants/main-action-style-types.js